import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const CreatorIntro = ({ isVisible, onComplete }) => {
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [showCursor, setShowCursor] = useState(true);

  const introText = "Welcome to my 3D Creative Universe";
  const subText = "Where Innovation Meets Imagination";

  useEffect(() => {
    if (!isVisible) return;

    setIsTyping(true);
    let index = 0;
    
    const typeText = () => {
      if (index < introText?.length) {
        setCurrentText(introText?.slice(0, index + 1));
        index++;
        setTimeout(typeText, 100);
      } else {
        setIsTyping(false);
        setTimeout(() => {
          onComplete();
        }, 2000);
      }
    };

    const delay = setTimeout(typeText, 1000);
    return () => clearTimeout(delay);
  }, [isVisible, onComplete]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);

    return () => clearInterval(cursorInterval);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm">
      <div className="text-center max-w-4xl px-6">
        {/* Main Title */}
        <div className="relative mb-8">
          <h1 className="font-headline font-black text-4xl md:text-6xl lg:text-7xl text-transparent bg-clip-text bg-gradient-to-r from-accent via-cosmic-energy to-cosmic-cta">
            {currentText}
            {(isTyping || showCursor) && (
              <span className="animate-pulse text-accent">|</span>
            )}
          </h1>
          
          {/* Glow Effect */}
          <div className="absolute inset-0 font-headline font-black text-4xl md:text-6xl lg:text-7xl text-accent/20 blur-sm">
            {currentText}
          </div>
        </div>

        {/* Subtitle */}
        {!isTyping && (
          <div className="animate-fade-in-up">
            <p className="font-body text-xl md:text-2xl text-muted-foreground mb-8">
              {subText}
            </p>
            
            {/* Creator Name */}
            <div className="flex items-center justify-center space-x-4 mb-12">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-accent to-cosmic-energy flex items-center justify-center cosmic-glow">
                <Icon name="User" size={24} className="text-background" />
              </div>
              <div className="text-left">
                <h2 className="font-headline font-bold text-2xl text-foreground">
                  Amit Pandey
                </h2>
                <p className="font-body text-muted-foreground">
                  3D Creative Developer
                </p>
              </div>
            </div>

            {/* Interactive Hint */}
            <div className="flex flex-col items-center space-y-4">
              <div className="flex items-center space-x-2 text-accent animate-bounce">
                <Icon name="MousePointer" size={20} />
                <span className="font-body text-sm">Click and drag to explore</span>
              </div>
              
              {/* Skip Button */}
              <button
                onClick={onComplete}
                className="font-body text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 underline"
              >
                Skip Introduction
              </button>
            </div>
          </div>
        )}

        {/* Floating Elements */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          {[...Array(20)]?.map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-accent rounded-full animate-float opacity-60"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 6}s`,
                animationDuration: `${4 + Math.random() * 4}s`
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreatorIntro;